<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">

    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
        <!-- <div>
            <button routerLink="add" *ngIf="permissionService.hasPermission([userPermission.MANAGE_CHANGE_REASON])"  class="btn btn-secondary">
                Add
            </button>
        </div> -->

          <div class="flex flex-col gap-4 sm:flex-row sm:gap-2">
            <!-- <div>
                        <select (change)="onSelectStatus($event)" id="inputStatus" class="min-w-40">
                            <option [value]="true">Active</option>
                            <option [value]="false">Inactive</option>
                        </select>
                    </div> -->
            <div class="relative">
                <input type="text" [(ngModel)]="search" (input)="onSearchInput()" placeholder="Search.." class="pl-8" />
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                    class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                </svg>
            </div>
        
            <div>
                <input type="text" name="time" id="time" [(ngModel)]="todayDate" [owlDateTime]="date"
                    (ngModelChange)="onDateChange($event)" [owlDateTimeTrigger]="date" [selectMode]="'range'" [readonly]="true" />
                <owl-date-time [pickerType]="'calendar'" #date></owl-date-time>
            </div>
    
        </div>

        <div *ngIf="gps && gps.length">
            <h1 class="text-xs text-nowrap text-left mr-3">Showing {{(50 * currentPage) - (gps.length !=
                50? (50
                -gps.length) : 0) }} of {{totalResults }} entries
            </h1>
        </div>

      
    </div>

    <div class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
        <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
            <div class="flow-root h-full overflow-y-auto">
                <div class="-my-2">
                    <div class="inline-block min-w-full py-2 align-middle">
                        <table class="min-w-full border-separate border-spacing-0">
                            <thead>
                                <tr>
                                    
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Driver</th>
                                         <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Company</th>
                                         <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Trip</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Latitude
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Longitude
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Speed
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Bearing
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Accuracy
                                    </th>
                                </tr>
                            </thead>
                        <tbody>
                            <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10"
                                *ngFor="let item of gps | paginate: { itemsPerPage: numberOfRecords, currentPage: currentPage, totalItems: totalResults }; let i=index">
                                <td *ngIf="item.driver" class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    {{item?.driver?.firstName | titlecase}} {{item?.driver?.lastName | titlecase}}
                                </td>
                                <td *ngIf="item.company" class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                     {{ item?.company?.name ? (item.company?.name | titlecase): ((item?.company | titlecase )|| 'N/A') }}
                                </td>
                                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    {{ item?.trip?.reference }}<span *ngIf="item?.trip?.suffix">-{{item?.trip?.suffix}}</span>
                                </td>

                                <td *ngIf="item?.location" class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
                                    {{item?.location?.coordinates[1]}} 
                                </td>
                                <td *ngIf="item?.location" class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
                                    {{item?.location?.coordinates[0]}} 
                                </td>

                                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
                                    {{item?.speed}} km/h
                                </td>
                                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
                                    {{item?.bearing}}°
                                </td>
                                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
                                    {{item?.accuracy}} m
                                </td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-end">
            <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
        </div>
    </div>
    
</section>